import { env } from './env';

export const mainApiBaseUrl = env('REACT_APP_MAIN_API_BASE_URL');
